module.exports = __webpack_public_path__ + "img/GazelEnergie.965f9e5a.png";